document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const swatchViews = node.matches(".swatch-view")
            ? [node]
            : node.querySelectorAll(".swatch-view");
          swatchViews.forEach((container) => {
            setupSwatchContainer(container);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll(".swatch-view").forEach(setupSwatchContainer);

  document.addEventListener("click", (e) => {
    const button = e.target.closest(".select-btn");
    if (button) {
      e.preventDefault();
      handleButtonClick(button);
    }
  });

  function setupSwatchContainer(container) {
    container
      .querySelectorAll(".swatch-view-item .swatch-image-wrapper")
      .forEach((swatch) => {
        if (swatch.dataset.swatchClickBound === "true") return;
        swatch.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            if (e.isTrusted) {
              handleSwatchClick(swatch);
            }
          },
          { passive: false }
        );
        swatch.dataset.swatchClickBound = "true";
      });
  }

  function handleSwatchClick(swatch) {
    const productCard = swatch.closest(".product-card");
    const selectButton = productCard.querySelector(".select-btn");
    const hiddenForm = productCard.querySelector(".product-card__hidden-form");
    const variantInput = hiddenForm?.querySelector(".product-variant-id");
    setTimeout(() => {
      const selectedVariantId = productCard?.getAttribute(
        "swatch-current-variant"
      );
      if (variantInput && selectedVariantId) {
        variantInput.value = selectedVariantId;
      }
    }, 0);

    if (selectButton) {
      selectButton.dataset.variantSelected = "true";
      selectButton.disabled = false;
    }
  }

  // function handleButtonClick(button) {
  //   const productCard = button.closest(".product-card");
  //   const section = productCard.closest(".featured-collection__items");
  //   const swatches = productCard.querySelector(".swatch-view");

  //   if (!button.dataset.variantSelected) {
  //     swatches?.classList.add("is-visible");
  //     const buttonSpan = button.querySelector("span");
  //     if (buttonSpan) buttonSpan.textContent = "Add to bag";
  //     button.disabled = true;
  //     const allSwatches = section?.querySelectorAll("variant-swatch-king") || [];
  //     allSwatches?.forEach((swatch) => swatch.classList.add("min-h"));
  //     return;
  //   }

  //   const hiddenForm = productCard.querySelector(".product-card__hidden-form");
  //   hiddenForm?.querySelector("button[type='submit']")?.click();
  // }

  function handleButtonClick(button) {
    const productCard = button.closest(".product-card");
    const section = productCard.closest(".featured-collection__items");

    const showSwatches = (swatches) => {
      swatches.classList.add("is-visible");
      const buttonSpan = button.querySelector("span");
      if (buttonSpan) buttonSpan.textContent = "Add to bag";
      button.disabled = true;
      const allSwatches =
        section?.querySelectorAll("variant-swatch-king") || [];
      allSwatches.forEach((swatch) => swatch.classList.add("min-h"));
      toggleLoadingSpinner(false);
    };

    const toggleLoadingSpinner = (show) => {
      const spinner = productCard.querySelector(
        ".cart-drawer .product-card__info .loading__spinner"
      );
      if (!spinner) return;
      if (show) {
        spinner.classList.remove("hidden");
      } else {
        spinner.classList.add("hidden");
      }
    };

    let swatches = productCard.querySelector(".swatch-view");
    console.log("🚀 ~ handleButtonClick ~ swatches initial:", swatches);
    if (!button.dataset.variantSelected) {
      toggleLoadingSpinner(true);
      if (swatches) {
        showSwatches(swatches);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && node.querySelector(".swatch-view")) {
              swatches = node.querySelector(".swatch-view");
              showSwatches(swatches);
              obs.disconnect();
              return;
            }
          }
        }
      });

      observer.observe(productCard, {
        childList: true,
        subtree: true,
      });

      return;
    }
    const hiddenForm = productCard.querySelector(".product-card__hidden-form");
    hiddenForm?.querySelector("button[type='submit']")?.click();
  }
});
